import { I18N } from "@aurelia/i18n";
import { inject } from "aurelia";

@inject(I18N)
export class PendingComponent {
  constructor(private I18N: I18N) { }
} 